import { useContext } from 'react';
import {
  Flex,
  ModalContext,
  Text,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';
import { FlexWraper, PaginationPerPageSelectWrap, ButtonWrap } from 'containers/properties/PropertyInventory/components/PropertyInventoryTableHeader/PropertyInventoryTableHeader.style';

function PropertyInventoryTableHeader() {
  const { t } = useTranslation('tables', { keyPrefix: 'inventory' });
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const { toggleModal } = useContext(ModalContext);

  return (
    <FlexWraper
      w="100%"
      px={6}
      py={4}
      justifyContent="space-between"
      flexDirection="row"
      alignItems="center"
      flex={1}
    >
      <Flex flex={1} flexDirection="row">
        <Text lg semibold>
          {t`units`}
        </Text>
      </Flex>
      <FlexWraper>
        <PaginationPerPageSelectWrap label={`${tLabels`show`} `} w={130} />
        <ButtonWrap
          ml={4}
          icon="plus"
          px={5.5}
          onClick={() => toggleModal(true)}
        >{t`addNewButtonLabel`}</ButtonWrap>
      </FlexWraper>
    </FlexWraper>
  );
}

export default PropertyInventoryTableHeader;
